const PINFL_WEIGHTS = [7, 3, 1];

/**
 * Validates an Uzbek ПИНФЛ (PINFL) — 14 decimal digits where the 14th digit
 * is a control digit computed from the first 13 digits modulo 10 with the
 * repeating weight function 7 3 1 7 3 1 … (КМ РУз № 200 от 31.05.1996, п. 2.5).
 */
export const isValidPinfl = (value: string): boolean => {
  if (!/^\d{14}$/.test(value)) return false;
  const digits = value.split("").map(Number);
  const sum = digits
    .slice(0, 13)
    .reduce((acc, digit, i) => acc + digit * PINFL_WEIGHTS[i % 3], 0);
  return sum % 10 === digits[13];
};
